<template>
    <div class="storeinfo">
        <m-title :titlelist="listitem"></m-title>
        <div class="store-box">
            <div class="store-title">
                <div class="carlist-box-title">
                    <div class="title-left"></div>
                    <div class="title-right">补能数据</div>
                </div>
                <div class="store-list">
                    <div class="store-left">
                        <img src="../../../assets/zuoye/pic_cdzbn.png" class="left-img" alt="">
                        <div class="left-info">
                            <div class="storeName">
                                <span class="yuan"></span>
                                <span class="name">{{ qianyanStation.locationName }}</span>
                            </div>
                            <div class="storeAdd">位置：天津市塘沽区南疆港港俊货场</div>
                            <div class="storeNum" @click="goaddstorestatelist(qianyanStation.locationName)">
                                <div class="numone">充电桩个数：<span style="color:#2F419B ;">{{ qianyanStation.pileNameCount }}</span></div>
                                <div class="numone">充电口个数：<span style="color:#2F419B ;">{{ qianyanStation.pilePortCount }}</span></div>
                            </div>
                            <div class="storeNum" @click="goaddstorestatelist(qianyanStation.locationName)">
                                <div class="numone">充电中桩数：<span style="color:#2F419B ;">{{ qianyanStation.chargePileCount }}</span></div>
                                <div class="numone">未充电桩数：<span style="color:#2F419B ;">{{ qianyanStation.unchargePileCount }}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="store-right">
                        <div class="storeItem" v-for="item in qianyandevice">
                            <img src="../../../assets//zuoye/pic_bluecdz.png" class="img" alt="">
                            <div class="store-Info">
                                <div class="name">{{ item[0].replace('前货场','前沿') }}</div>
                                <div class="nameB" v-for="i in item[1]">
                                    <div class="nameA" @click='goaddstoredetail(i.name,item[0])'>{{i.name.includes('A')?'A口':'B口'}}：{{ i.status==1?'空闲':'充电中' }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="store-title" style="margin-top: 20px;">
                <div class="store-list">
                    <div class="store-left">
                        <img src="../../../assets/zuoye/pic_green.png" class="left-img" alt="">
                        <div class="left-info">
                            <div class="storeName">
                                <span class="yuan"></span>
                                <span class="name">{{ gangjunStaion.locationName }}</span>
                            </div>
                            <div class="storeAdd">位置：天津市塘沽区南疆港港俊货场</div>
                            <div class="storeNum" @click="goaddstorestatelist(gangjunStaion.locationName)">
                                <div class="numone">充电桩个数：<span style="color:#2F419B ;">{{ gangjunStaion.pileNameCount }}</span></div>
                                <div class="numone">充电口个数：<span style="color:#2F419B ;">{{ gangjunStaion.pilePortCount }}</span></div>
                            </div>
                            <div class="storeNum" @click="goaddstorestatelist(gangjunStaion.locationName)">
                                <div class="numone">充电中桩数：<span style="color:#2F419B ;">{{ gangjunStaion.chargePileCount }}</span></div>
                                <div class="numone">未充电桩数：<span style="color:#2F419B ;">{{ gangjunStaion.unchargePileCount }}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="store-right">
                        <div class="storeItem" v-for="item of gangjundevice">
                            <img src="../../../assets/zuoye/pic_bluecdz.png" class="img" alt="">
                            <div class="store-Info">
                                <div class="name">{{ item[0] }}</div>
                                <div class="nameB" v-for="i in item[1]">
                                    <div class="nameA" @click='goaddstoredetail(i.name,item[0])'>{{i.name.includes('A')?'A口':'B口'}}：{{ i.status==1?'空闲':'充电中' }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mTitle from "@/components/mTitle";
export default {
    components: {
        mTitle,
    },
    data() {
        return {
            listitem: [{ name: "充电补能展示" }],
            gangjunStaion:{},
            qianyanStation:{},
            qianyandevice:{},
            gangjundevice:{}
        }
    },
    mounted() {
        this.getdeviceListQY()
        this.getdeviceListGJ()
        this.getpileDevicestatisticsQian()
        this.getpileDevicestatisticsGang()
    },
    methods: {
        goaddstorestatelist(station){
            this.$router.push({name:'addstorestatelist',query:{station}})
        },
        goaddstoredetail(i,station){
            let stationname
            if(station.includes('前货场')){
                stationname='前货场'
            }else{
                stationname='港俊'
            }
            this.$router.push({name:'addstoredetail',query:{name:i,stationname}})
        },
        // 充电补能数据统计 
        async getdeviceListQY() {
            const { data } = await this.$http(
                "api1",
                "/api/replenish/station/deviceList",
                "get",
                {station:'前货场'}
            )
            if (!data || data.code != 0) return
            this.qianyandevice=Object.entries(data.data)
        },
        async getdeviceListGJ() {
            const { data } = await this.$http(
                "api1",
                "/api/replenish/station/deviceList",
                "get",
                {station:'港俊'}
            )
           
            if (!data || data.code != 0) return

            this.gangjundevice=Object.entries(data.data)
        },
        async getpileDevicestatisticsQian() {
            const { data } = await this.$http(
                "api1",
                "/api/replenish/station/pileDeviceStatistics",
                "get",
                {station:'前货场'}
            )
            if (!data || data.code != 0) return
            this.qianyanStation=data.data[0]
        },
        async getpileDevicestatisticsGang() {
            const { data } = await this.$http(
                "api1",
                "/api/replenish/station/pileDeviceStatistics",
                "get",
                {station:'港俊'}
            )
            if (!data || data.code != 0) return
            this.gangjunStaion=data.data[0]
        },
    },
   
}
</script>

<style lang="scss" scoped>
@mixin start {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

@mixin between {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@mixin column {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
}

.storeinfo {
    width: 100%;
    height: 100%;

    .store-box {
        width: 100%;
        height: calc(100% - 50px);
        background: #F5F6FA;
        border-radius: 20px;
        overflow: auto;
        padding: 10px;
        box-sizing: border-box;

        .store-title {
            width: 100%;
            background: #FFFFFF;
            border-radius: 20px;
            padding: 20px;
            box-sizing: border-box;

            .carlist-box-title {
                @include start;
                padding-bottom: 25px;

                .title-left {
                    width: 12px;
                    height: 26px;
                    background: #17B6A1;
                    border-radius: 6px;
                    margin-right: 11px;
                }

                .title-right {
                    font-size: 20px;
                    font-family: PingFang SC;
                    font-weight: 600;
                    color: #2D3748;
                }
            }
            .store-list{
                @include between;
                height: 150px;
                .store-left{
                    @include between;
                    width: 35%;
                    height: 100%;
                    .left-img{
                        width: 200px;
                       
                    }
                    .left-info{
                        @include column;
                        height: 100%;
                        .storeName{
                            .yuan{
                                display: inline-block;
                                width: 10px;
                                height: 10px;
                                background: #17B6A1;
                                border-radius: 6px;
                                margin-right: 5px;
                            }
                            .name{
                                font-weight: bold;
                                font-size: 20px;
                                color: #2D3748;
                            }
                        }
                        .storeAdd{
                            font-size: 80%;
                            color: #2F419B;
                        }
                        .storeNum{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            font-size: 80%;
                            cursor: pointer;
                        }
                    }
                }
                .store-right{
                    width: 64%;
                    height: 100%;
                    display: grid;
                    grid-template-columns: repeat(5, 19%);
                    grid-row-gap:10px;
                    justify-content: space-between ;
                    .storeItem{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .img{
                            width: 53px;
                        }
                        .store-Info{
                            width: 59%;
                            @include column;
                            font-size: 70%;
                            .name{
                                color: #333333;
                            }
                            .nameA{
                                cursor: pointer;
                                color: #2F419B;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>